export class LoadMeasurementError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "LoadMeasurementError";
  }
}
